import React, { useContext } from 'react'
import { Spinner } from 'react-bootstrap'
import { ThemeContext } from './ThemeContext.js'

const Loader = () => {
  const { theme } = useContext(ThemeContext)

  return (
    <Spinner
      className='spinner-border'
      role='status'
      style={{
        color: theme.sidebarAccent,
        width: '100px',
        height: '100px',
        margin: 'auto',
        display: 'block'
      }}
    >
      <span className='visually-hidden'>Loading...</span>
    </Spinner>
  )
}

export default Loader
